import { render, staticRenderFns } from "./LotesPesquisa.vue?vue&type=template&id=3a2a3c13&scoped=true"
import script from "./LotesPesquisa.vue?vue&type=script&lang=js"
export * from "./LotesPesquisa.vue?vue&type=script&lang=js"
import style0 from "./LotesPesquisa.vue?vue&type=style&index=0&id=3a2a3c13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2a3c13",
  null
  
)

export default component.exports